export default __webpack_public_path__ + "static/media/success-illustration.d3077cb8.svg";